import { createFileRoute } from '@tanstack/react-router';

import { TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';
import { requireNonAdhocLocation } from 'shared/modules/locations';
import { routes } from 'shared/routes';

import { AiVisibilitySettings } from 'features/reports/ai-visibility/AiVisibilitySettings';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/ai-visibility/settings/')({
  staticData: { breadcrumb: 'aiVisibilitySettings' },
  // Loaders run in parallel, so the guard shares the `$id` loader's in-flight location request.
  loader: ({ context: { queryClient }, params: { id } }) =>
    requireNonAdhocLocation(queryClient, id, { fallbackRoute: routes.locations() }),
  component: AiVisibilitySettingsRoute
});

function AiVisibilitySettingsRoute() {
  const { id } = Route.useParams();

  return (
    <ToolAccessGate
      gate={TOOL_GATES.AI_VISIBILITY}
      locationId={id}
      page={LOCATION_DATA_UNAVAILABLE_PAGE.AI_VISIBILITY}
      titleKey="reports.aiVisibility.settings.title"
    >
      <AiVisibilitySettings locationId={id} />
    </ToolAccessGate>
  );
}
